export default __webpack_public_path__ + "static/media/kitchen3-after3-1440w.ee7a812c.png";